import React, { useCallback, useLayoutEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import CreditCardForm from '../me/CreditCardForm';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { Screens } from '../../constants/ScreenNames';

const CreditCardModal = ({ navigation, route }) => {
  const { countryList, creditCard, creditCardTypes, creditCardProviders } = route.params;
  const { tKey } = useComponentTKey('CreditCardForm');
  const { t } = useTranslation(i18nNS.me);
  const getTitle = useCallback(() => {
    if (creditCard) {
      return t(tKey('Save'));
    } else {
      return t(tKey('New'));
    }
  }, [creditCard, t, tKey]);

  const refreshCreditCardList = () => {
    navigation.navigate(Screens.Me);
  };

  useLayoutEffect(() => {
    navigation.setOptions({
      title: getTitle(),
    });
  }, [getTitle, navigation]);

  return (
    <View style={styles.body}>
      <CreditCardForm
        countryList={countryList}
        onSubmit={refreshCreditCardList}
        onDelete={refreshCreditCardList}
        creditCard={creditCard}
        creditCardTypes={creditCardTypes}
        creditCardProviders={creditCardProviders}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    flex: 1,
    backgroundColor: 'white',
  },
});

export default CreditCardModal;
